import adminApiClient from './apiClient.js';

export const automacoesApi = {
  list: async ({ origem, page = 1, pageSize = 20, tipoAutomacao, status, search } = {}) => {
    const params = { origem, page, page_size: pageSize };
    if (tipoAutomacao) params.tipo_automacao = tipoAutomacao;
    if (status) params.status = status;
    if (search) params.search = search;
    const { data } = await adminApiClient.get('/automacoes/', { params });
    return data;
  },
  remove: async (origem, automacaoId) => {
    const { data } = await adminApiClient.delete(`/automacoes/${origem}/${automacaoId}`);
    return data;
  },
  insightsDiario: async (dias = 30) => {
    const { data } = await adminApiClient.get('/automacoes/insights-diario', { params: { dias } });
    return data;
  },
};

export default automacoesApi;
